import React, { useEffect, useState } from "react";

const Wallet = ({ active }) => {
  return (
    <svg
      className="w-6 h-6"
      viewBox="0 0 27 25"
      xmlns="http://www.w3.org/2000/svg"
      fill={active ? "#BA004F" : "#C1A4A4"}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.709 1.02944L1.75578 5.76189C1.20527 5.92563 0.877975 6.55247 1.0257 7.162C1.04391 7.23724 1.06851 7.3087 1.09868 7.37586C1.0343 7.57214 0.999485 7.78181 0.999485 7.99962V22.9995C0.999485 24.1041 1.89503 24.9999 2.99941 24.9999H22.9996C24.1045 24.9999 24.9995 24.1041 24.9995 22.9995V19.829C26.1644 19.4171 26.9991 18.306 26.9991 16.9999V14C26.9991 12.6936 26.1644 11.5824 24.9995 11.1705V7.99962C24.9995 6.89499 24.1045 5.99961 22.9996 5.99961H8.93164L18.2434 3.2371C18.7939 3.07375 19.1209 2.44689 18.973 1.83775C18.8255 1.22824 18.2598 0.866062 17.709 1.02944ZM22.9996 7.99962V10.9998H17.9996C16.3429 10.9998 14.9996 12.3429 14.9996 14V16.9999C14.9996 18.6566 16.3429 19.9997 17.9996 19.9997H22.9996V22.9995H2.99941V7.99962H22.9996ZM23.9996 12.9994H17.9996C17.4475 12.9994 16.9995 13.4471 16.9995 14V16.9999C16.9995 17.552 17.4475 17.9997 17.9996 17.9997H23.9996C24.552 17.9997 24.9995 17.552 24.9995 16.9999V14C24.9995 13.4471 24.552 12.9994 23.9996 12.9994ZM19.4996 14C20.3281 14 20.9996 14.6716 20.9996 15.4996C20.9996 16.3283 20.3281 16.9999 19.4996 16.9999C18.6711 16.9999 17.9996 16.3283 17.9996 15.4996C17.9996 14.6716 18.6711 14 19.4996 14Z"
      />
    </svg>
  );
};

export default Wallet;
